// Module scripts execute once even when multiple sections include this asset.
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-quickbuy] select');
  if (!select) return;
  const form = select.form;
  const card = form.closest('[data-quickbuy-card]');
  const option = select.selectedOptions[0];
  card.querySelector('[data-quickbuy-price]').textContent = option.dataset.price;
  card.querySelector('[data-quickbuy-unit]').textContent = option.dataset.unit;
  card.querySelector('[data-quickbuy-stock]').textContent = option.dataset.available === 'true' ? form.dataset.stock : form.dataset.sold;
  form.querySelector('button').disabled = option.dataset.available !== 'true';
  form.querySelector('[data-quickbuy-status]').textContent = '';
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quickbuy]');
  if (!form) return;
  event.preventDefault();
  if (form.dataset.pending === 'true') return;
  const select = form.querySelector('select');
  const option = select.selectedOptions[0];
  if (select.disabled || !option || option.disabled || option.dataset.available !== 'true') return;
  const button = form.querySelector('button');
  const status = form.querySelector('[data-quickbuy-status]');
  const originalLabel = button.textContent;
  form.dataset.pending = 'true';
  button.disabled = true;
  select.disabled = true;
  button.textContent = form.dataset.busy;
  status.textContent = '';
  try {
    const response = await fetch(`${form.action}.js`, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(option.value), quantity: 1 }] })
    });
    const result = await response.json();
    if (!response.ok) {
      status.textContent = typeof result.description === 'string' ? result.description : form.dataset.error;
      return;
    }
    if (!Array.isArray(result.items) || !result.items.some(item => String(item.variant_id || item.id) === option.value && item.quantity > 0)) {
      throw new Error('Cart response did not confirm the selected variant');
    }
    status.textContent = form.dataset.added;
    form.querySelector('[data-quickbuy-cart]').hidden = false;
    // The purchase is already confirmed; a badge refresh failure must not invite a duplicate add.
    try {
      const cartLink = form.querySelector('[data-quickbuy-cart]');
      const cartResponse = await fetch(`${cartLink.href}.js`, { credentials: 'same-origin' });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('.nx-cart__count').forEach(node => { node.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('nlx:cart-updated', { detail: cart }));
      }
    } catch { /* Confirmed addition remains successful. */ }
  } catch {
    status.textContent = form.dataset.error;
    form.querySelector('[data-quickbuy-cart]').hidden = false;
  } finally {
    form.dataset.pending = 'false';
    select.disabled = false;
    button.disabled = false;
    button.textContent = originalLabel;
  }
});
